import {Injectable} from "@angular/core";
import {DxAuthenticationStrategy} from "./dx-authentication-strategy";
import {Observable} from "rxjs/index";
import {DxAuthentication} from "../../../domain/authentication/dx-athentication";
import {DxHttpDispatcher} from "../../../../dx-core/services/dx-http-dispatcher.service";
import {DxOperationResultType} from "../../../../dx-core/domain/common/dx-operation-result-type";
import {fromPromise} from "rxjs/internal/observable/fromPromise";
import {DxUser} from "../../../domain/user/dx-user";
import {DxObjectMapper} from "../../../../dx-core/services/dx-object-mapper.service";
import {DxEncryptionService} from "../../../../dx-core/services/dx-encryption.service";


@Injectable()
export class DxBasicAuthenticationStrategy implements DxAuthenticationStrategy {

  constructor(private _http: DxHttpDispatcher,
              private _mapper: DxObjectMapper,
              private _encryptor: DxEncryptionService) { }

  public authenticate(login: string, password: string): Observable<DxAuthentication> {
    const authentication: DxAuthentication = new DxAuthentication();
    const promise: Promise<DxAuthentication> = new Promise((resolve) => {
      // TODO: Пока GET-запрос. Для полноценной эмуляции POST-запроса для уантификации
      // TODO: Нужно писать перехватчик отдельный
      this._http.get('authenticate').subscribe(response => {
        authentication.authResult = DxOperationResultType.SUCCESS;
        authentication.token = response.body[0];

        const rawData = this._encryptor.decode(authentication.token);
        authentication.user = this._mapper.deserialize<DxUser>(rawData, DxUser);

        resolve(authentication);
      }, errorResponse => {
        const error = DxHttpDispatcher.handleHttpError(errorResponse);
        authentication.authResult = DxOperationResultType.FAILED;
        authentication.error = error.message;

        resolve(authentication);
      });

    });
    return fromPromise(promise);
  }
}
